import PropTypes from 'prop-types';

import PersonCard from '../../PersonCard/PersonCard';

const PersonBody = ({
  content,
  layout,
  summary,
  showDescription,
  hideName,
  showPersonLink,
  isEditMode,
}) => {
  if (!content) return null;

  return (
    <PersonCard
      person={content}
      layout={layout}
      summary={summary}
      showDescription={showDescription}
      hideName={hideName}
      showPersonLink={showPersonLink}
      isEditMode={isEditMode}
    />
  );
};

PersonBody.propTypes = {
  content: PropTypes.object,
  layout: PropTypes.string,
  summary: PropTypes.bool,
  showDescription: PropTypes.bool,
  hideName: PropTypes.bool,
  showPersonLink: PropTypes.bool,
};

export default PersonBody;
